import {
  FACILITY_HISTORY_DETAIL_SEARCH, FACILITY_HISTORY_DETAIL_SEARCH_FAILURE, FACILITY_HISTORY_DETAIL_SEARCH_SUCCESS,
  FACILITY_HISTORY_DETAIL_DELETE, FACILITY_HISTORY_DETAIL_DELETE_FAILURE, FACILITY_HISTORY_DETAIL_DELETE_SUCCESS,
  FACILITY_HISTORY_DETAIL_NOTICE_MODIFY, FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_FAILURE, FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_SUCCESS,
  FACILITY_HISTORY_DETAIL_STOP, FACILITY_HISTORY_DETAIL_STOP_FAILURE, FACILITY_HISTORY_DETAIL_STOP_SUCCESS,
  FACILITY_HISTORY_DETAIL_SEND_MEDINFO, FACILITY_HISTORY_DETAIL_SEND_MEDINFO_FAILURE, FACILITY_HISTORY_DETAIL_SEND_MEDINFO_SUCCESS,
  FACILITY_HISTORY_DETAIL_PRINT, FACILITY_HISTORY_DETAIL_PRINT_FAILURE, FACILITY_HISTORY_DETAIL_PRINT_SUCCESS,
  FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF, FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_FAILURE, FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_SUCCESS,
  FACILITY_HISTORY_DETAIL_PRINT_DELETE, FACILITY_HISTORY_DETAIL_PRINT_DELETE_FAILURE, FACILITY_HISTORY_DETAIL_PRINT_DELETE_SUCCESS,
  FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE, FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE, FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS,
  FACILITY_HISTORY_DETAIL_CLEAR
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    facilityDetailAuth: null,
    facilityDetailHistorys: null,
    facilityDetailNotify: null,
    facilityImages: null
  },
  getters: {
    /** 認証情報のみ */
    facilityDetailAuth: state => {
      return state.facilityDetailAuth
    },
    /** 施設詳細履歴 */
    facilityDetailHistorys: state => {
      return state.facilityDetailHistorys
    },
    /** 通知 */
    facilityDetailNotify: state => {
      return state.facilityDetailNotify
    },
    /** 画像 */
    facilityImages: state => {
      return state.facilityImages
    }
  },
  actions: {
    /** クリア */
    [FACILITY_HISTORY_DETAIL_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(FACILITY_HISTORY_DETAIL_CLEAR)
      }, sleep)
    },
    /** 検索 */
    [FACILITY_HISTORY_DETAIL_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/detail'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_DETAIL_SEARCH_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_DETAIL_SEARCH_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** 履歴削除 */
    [FACILITY_HISTORY_DETAIL_DELETE] ({dispatch, state, commit}, params) {
      dispatch('apiDelete', {url: '/facility_histories/' + params.historyId})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_DETAIL_DELETE_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_DETAIL_DELETE_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** 取引中止 */
    [FACILITY_HISTORY_DETAIL_STOP] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/stop'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_DETAIL_STOP_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_DETAIL_STOP_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** 注意書き 状態変更 */
    [FACILITY_HISTORY_DETAIL_NOTICE_MODIFY] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/modify'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** メール送信 */
    [FACILITY_HISTORY_DETAIL_SEND_MEDINFO] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/send_medinfo'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_DETAIL_SEND_MEDINFO_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_DETAIL_SEND_MEDINFO_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** ログインID・パスワード通知PDF印刷 */
    [FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/print_notify'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_SUCCESS, {
                data: res.data,
                callback: params.callback,
                win: params.win
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** PDF印刷 */
    [FACILITY_HISTORY_DETAIL_PRINT] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/print'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_DETAIL_PRINT_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_DETAIL_PRINT_SUCCESS, {
                data: res.data,
                callback: params.callback,
                win: params.win
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** ログインID・パスワード通知PDF印刷削除 */
    [FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/print_notify_delete'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: false})
        .then(res => {
          if (res.data.error) {
            commit(FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE, res.data)
          } else {
            commit(FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS, {
              data: res.data
            })
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** PDF印刷削除 */
    [FACILITY_HISTORY_DETAIL_PRINT_DELETE] ({dispatch, state, commit}, params) {
      var url = '/facility_histories/print_delete'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: false})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_HISTORY_DETAIL_PRINT_DELETE_FAILURE, res.data)
            } else {
              commit(FACILITY_HISTORY_DETAIL_PRINT_DELETE_SUCCESS, {
                data: res.data
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [FACILITY_HISTORY_DETAIL_CLEAR] (state) {
      state.facilityDetailAuth = null
      state.facilityDetailHistorys = null
      state.facilityImages = null
    },
    /** 検索 失敗 */
    [FACILITY_HISTORY_DETAIL_SEARCH_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_SEARCH_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** 検索 成功 */
    [FACILITY_HISTORY_DETAIL_SEARCH_SUCCESS] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_SEARCH_SUCCESS')
      state.facilityDetailAuth = params.data.facility
      state.facilityDetailHistorys = params.data.facility_history.data
      state.facilityImages = params.data.image_attach
      if (params.callback !== null) {
        params.callback(state.facilityDetailHistorys)
      }
    },

    /** 履歴削除 失敗 */
    [FACILITY_HISTORY_DETAIL_DELETE_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_DELETE_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.delete.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** 履歴削除 成功 */
    [FACILITY_HISTORY_DETAIL_DELETE_SUCCESS] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_DELETE_SUCCESS')
      // 通知
      state.facilityDetailNotify = {
        success: true,
        message_i18n: 'messages.delete.success'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
      if (params.callback !== null) {
        params.callback()
      }
    },

    /** 取引中止 失敗 */
    [FACILITY_HISTORY_DETAIL_STOP_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_STOP_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** 取引中止 成功 */
    [FACILITY_HISTORY_DETAIL_STOP_SUCCESS] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_STOP_SUCCESS')
      state.facilityDetailAuth = params.data.facility
      state.facilityDetailHistorys = params.data.facility_history.data
      state.facilityImages = params.data.image_attach
      var message = ''
      if (params.data.enable_flag === 0) {
        // 取引停止
        message = 'messages.save.facility_stop_success'
      } else {
        // 取引再開
        message = 'messages.save.facility_restart_success'
      }
      params.callback()

      // 通知
      state.facilityDetailNotify = {
        success: true,
        message_i18n: message
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },

    /** 注意書き 状態変更 失敗 */
    [FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.search.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** 注意書き 状態変更 成功 */
    [FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_SUCCESS] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_NOTICE_MODIFY_SUCCESS')
      // 内容を最新に更新
      var updateData = params.data.facility_history.data[0]
      var id = parseInt(params.data.facility_history_id, 10)
      for (var i = 0; i < state.facilityDetailHistorys.length; i++) {
        var d = state.facilityDetailHistorys[i].attributes
        if (parseInt(d.facility_history_id, 10) === id) {
          state.facilityDetailHistorys[i] = updateData
          break
        }
      }
      params.callback(updateData)
    },

    /** メール送信 失敗 */
    [FACILITY_HISTORY_DETAIL_SEND_MEDINFO_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_SEND_MEDINFO_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.send_medinfo.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** メール送信 成功 */
    [FACILITY_HISTORY_DETAIL_SEND_MEDINFO_SUCCESS] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_SEND_MEDINFO_SUCCESS')
      // 通知
      state.facilityDetailNotify = {
        success: true,
        message_i18n: 'messages.send_medinfo.success'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
      if (params.callback !== null) {
        params.callback(params.data)
      }
    },

    /** ログインID・パスワード通知PDF印刷 失敗 */
    [FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.print.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** PDF印刷 失敗 */
    [FACILITY_HISTORY_DETAIL_PRINT_FAILURE] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_PRINT_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.print.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** ログインID・パスワード通知PDF印刷 成功 */
    [FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_SUCCESS] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_SUCCESS')
      if (params.callback !== null) {
        params.callback(params.data, params.win)
      }
    },
    /** PDF印刷 成功 */
    [FACILITY_HISTORY_DETAIL_PRINT_SUCCESS] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_PRINT_SUCCESS')
      if (params.callback !== null) {
        params.callback(params.data, params.win)
      }
    },
    /** ログインID・パスワード通知印刷削除失敗 */
    [FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE')
    },
    /** 印刷削除失敗 */
    [FACILITY_HISTORY_DETAIL_PRINT_DELETE_FAILURE] (state, params) {
      console.log('FACILITY_HISTORY_DETAIL_PRINT_DELETE_FAILURE')
    },
    /** ログインID・パスワード通知印刷削除成功 */
    [FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS')
    },
    /** 印刷削除成功 */
    [FACILITY_HISTORY_DETAIL_PRINT_DELETE_SUCCESS] (state, data) {
      console.log('FACILITY_HISTORY_DETAIL_PRINT_DELETE_SUCCESS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/facility-detail.js